import { useTLang } from 'intl/intl';

export function useOrdersHistoricalLang() {
  return {
    info: useTLang({ id: 'ordersHistorical.infoLabel' }),
    emptyState: useTLang({ id: 'ordersHistorical.emptyStateText' }),
  };
}
